/* eslint-disable react/prop-types */
import { useEffect, useState } from 'react'
import { CheckIconModal } from '../CheckIconModal'

const DefaultDescription = () => (
  <>
    Sua campanha fica salva no seu histórico para baixar quando decidir. E o cupom{' '}
    <strong>PRIMEIRA20</strong> é valido por 24h.
  </>
)

function wrapExitAction(
  action,
  selectedFeedback,
  { requireSelection = true, onExitWithFeedback } = {},
) {
  if (!action) {
    return undefined
  }

  const hasSelection = !!selectedFeedback

  if (!requireSelection) {
    return action
  }

  return {
    ...action,
    disabled: !hasSelection || action.disabled,
    onClick: () => {
      if (!hasSelection) {
        return
      }

      onExitWithFeedback?.(selectedFeedback)
      action.onClick?.(selectedFeedback)
    },
  }
}

export const ExitFeedbackModal = ({
  isOpen,
  onClose,
  title = 'Tudo bem!',
  description,
  feedback,
  primaryAction,
  secondaryAction,
  backAction,
  onExitWithFeedback,
  showCheckIcon = true,
  showCloseButton = true,
}) => {
  const [selectedFeedback, setSelectedFeedback] = useState(null)
  const resolvedSecondaryAction = secondaryAction ?? backAction

  useEffect(() => {
    if (!isOpen) {
      setSelectedFeedback(null)
    }
  }, [isOpen])

  return (
    <CheckIconModal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      titleId="exit-feedback-modal-title"
      description={description ?? <DefaultDescription />}
      feedback={
        feedback
          ? {
            ...feedback,
            question:
                feedback.question ?? 'Antes de ir: o que faria você comprar hoje?',
            selectedId: selectedFeedback?.id ?? null,
            onSelect: (option) => {
              setSelectedFeedback(option ?? null)
              if (option) {
                feedback.onSelect?.(option)
              }
            },
          }
          : null
      }
      primaryAction={wrapExitAction(primaryAction, selectedFeedback, {
        requireSelection: false,
      })}
      secondaryAction={wrapExitAction(resolvedSecondaryAction, selectedFeedback, {
        onExitWithFeedback,
      })}
      showCloseButton={showCloseButton}
      showCheckIcon={showCheckIcon}
    />
  )
}

export default ExitFeedbackModal
